import React from 'react'
import {
  makeStyles,
  styled,
  Radio,
  CircularProgress,
  Backdrop
} from '@material-ui/core'

import { useHistory } from 'react-router-dom'
import moment from 'moment'
import heic2any from 'heic2any'
import { Field } from 'redux-form'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { isEmpty } from 'lodash'
import InputSelect from '../select/InputSelect'

import Button from '../button/Button'
import MaterialInput from '../shared/MaterialInput'
import { TimePickerInput } from '../shared/DatePickerInput'
import RelationSelect from '../select/RelationshipSelect'
import {
  required,
  validEmail,
  capitalize,
  normalizePhone,
  normalizeCPF,
  validPhone,
  isValidCPF
} from '../../utils/formUtils'
import { handleAddAvatar } from '../../utils/helpers'
import StyledSVG from '../shared/StyledSVG'
import cameraSVG from '../../assets/icons/camera-icon.svg'
import warningSVG from '../../assets/icons/rounded-yellow-warning.svg'

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  root: {
    maxWidth: 800,
    height: '100%',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  responsible_section: {
    display: 'flex',
    flexDirection: 'column',
    '& .label': {
      fontWeight: 600,
      fontSize: 20,
      color: '#386093',
      margin: 0
    },
    marginTop: 72
  },
  estimated_arrival: {
    marginTop: 72,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    '& h1': {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,
      color: '#386093'
    },
    '& .input_wrapper': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 16,
      '& p': {
        fontWeight: 400,
        fontSize: 16,
        margin: 0,
        color: '#9B9B9B'
      }
    },
    [theme.breakpoints.down('1000')]: {
      marginBottom: 20
    }
  },
  without_photo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 8,
    '& svg': {
      '& path': {
        stroke: '#9BA6BB'
      }
    },
    '& p': {
      fontWeight: 600,
      fontSize: 12,
      color: '#9BA6BB',
      margin: 0
    }
  },
  responsible_fields: {
    display: 'flex',
    columnGap: 40,
    marginTop: 24,
    [theme.breakpoints.down('1000')]: {
      flexDirection: 'column'
    }
  },
  bottom_btns: {
    display: 'flex',
    gap: 12,
    justifyContent: 'flex-end',
    paddingBottom: 16,
    marginTop: 36,
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  cancel_btn: {
    width: 146,
    border: '1px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '1px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  send_btn: {
    backgroundColor: '#386093',
    width: 148,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  time_picker_class: {
    width: 100,
    '& .MuiInputBase-root': {
      height: '40px !important'
    }
  },
  remove_photo: {
    position: 'absolute',
    right: 2,
    top: 2
  },
  search_component: {
    width: '100%',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  identification_infos_wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 24
  },
  identification_item: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .label': {
      fontSize: 12,
      fontWeight: 600,
      margin: 0
    }
  },
  options: {
    '& .child_name_wrapper': {
      height: 48,
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#F5F6F7'
      },
      '& p': {
        paddingLeft: 8,
        margin: 0,
        cursor: 'pointer'
      }
    }
  },
  children_seleted: {
    backgroundColor: '#E9FAD9 !important',
    '&:hover': {
      backgroundColor: '#E9FAD9 !important'
    }
  },
  pagination: {
    float: 'right',
    paddingTop: '15px',
    [theme.breakpoints.down('426')]: {
      float: 'unset',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap'
      }
    }
  },
  child_pagination_wrapper: {
    width: '100%',
    '& .MuiPagination-root': {
      padding: '0px 24px 12px 0px'
    }
  },
  selected_childrens: {
    display: 'flex',
    columnGap: 8,
    rowGap: 12,
    flexWrap: 'wrap',
    marginTop: 8
  },
  selected_childrens_item: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: 8,
    borderRadius: 8,
    backgroundColor: '#D9E8FA',
    '& p': {
      margin: 0,
      fontSize: 14,
      fontWeight: 500
    },
    '& .remove_child': {
      cursor: 'pointer',
      '& path': {
        fill: '#222A33'
      }
    }
  },
  radio_wrapper: {
    display: 'flex',
    gap: 80,
    '& .radioButton': {
      display: 'flex',
      columnGap: 24,
      '& .MuiRadio-root': {
        padding: 0
      },
      [theme.breakpoints.down('600')]: {
        columnGap: 5
      }
    },
    [theme.breakpoints.down('600')]: {
      gap: 10
    }
  },
  contact_infos: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    columnGap: 40,
    rowGap: 16,
    [theme.breakpoints.down('1000')]: {
      marginTop: 20,
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))'
    }
  },
  capitalized_input: {
    '& .MuiInput-input': {
      textTransform: 'capitalize'
    }
  },
  material_input_class: {
    width: '100%',
    height: 40,
    marginBottom: '0px !important',
    '& .MuiSelect-select.MuiSelect-select': {
      color: '#D2D5D8'
    }
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    height: 'fit-content',
    '& p.label': {
      margin: 0,
      fontSize: 12,
      fontWeight: 600,
      color: '#555555'
    },
    [theme.breakpoints.down('1000')]: {
      gridColumn: 'span 12'
    }
  },
  warning_section: {
    marginTop: 32,
    height: 56,
    width: '100%',
    borderRadius: 16,
    backgroundColor: '#FEF7DD',
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    columnGap: 12,
    [theme.breakpoints.down('700')]: {
      height: 80
    },
    [theme.breakpoints.down('600')]: {
      height: 120
    }
  },
  warning_message: {
    fontSize: 14,
    margin: 0
  },
  input_select_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24,
    '& .input-label': {
      color: '#386093',
      fontSize: 20,
      fontWeight: 600,
      margin: 0
    },
    '& .description': {
      margin: 0,
      marginTop: 16,
      fontSize: 16,
      fontWeight: 400
    }
  },
  parent_select: {
    marginBottom: 72,
    [theme.breakpoints.down('1000')]: {
      marginBottom: 20
    }
  },
  bull: {
    color: '#8B598E',
    fontSize: '1.3rem',
    verticalAlign: 'text-bottom',
    marginLeft: '0.8rem'
  }
}))

const FormFieldWrapper = styled('div')(({ theme, gridColumn }) => ({
  gridColumn: `span ${gridColumn || 6}`
}))

const PhotoInput = styled('div')(({ theme, bgImg }) => ({
  minWidth: 170,
  height: 170,
  borderRadius: 12,
  backgroundColor: '#EFF1F5',
  position: 'relative',
  backgroundSize: 'cover',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: bgImg
}))

const WarningMessage = ({ permanent, classes }) => {
  if (permanent) {
    return (
      <p className={classes.warning_message}>
        A escola analisará os dados para <b>garantir a segurança da criança</b>.
        Você será notificado.
      </p>
    )
  }
  return (
    <p className={classes.warning_message}>
      <b>Autorização válida apenas hoje</b>. Expira ao final do dia letivo.
    </p>
  )
}

const CreatePickupAuthorizationsForm = ({
  createPickupAuthorizationRSPA,
  editPickupAuthorizationRSPA,
  alert,
  valid,
  currentUser,
  schoolId,
  getChildrenRSPA,
  fieldValues,
  clearCurrentAuthorization,
  initialValues,
  isEdit,
  currentAuthorization,
  getUsers
}) => {
  const classes = useStyles()
  const history = useHistory()
  const reponsiblePhotoRef = React.useRef(null)
  const [selectedChildrens, setSelectedChildrens] = React.useState([])
  const [selectedParent, setSelectedParent] = React.useState([])
  const [openBackdrop, setOpenBackdrop] = React.useState(false)
  const [permanentAuthorization, setPermanentAuthorization] = React.useState({
    value: true,
    days: []
  })
  const [uploadingInProgress, setUploadingInProgress] = React.useState(false)
  const [responsiblePhoto, setResponsiblePhoto] = React.useState({
    url: null,
    file: null,
    delete: false
  })
  const loadedAuthorization = !isEmpty(initialValues)

  // limpar ao sair do form
  React.useEffect(() => {
    return () => {
      clearCurrentAuthorization()
    }
  }, [])

  // setar dados que nao estão atrelados ao redux-form
  React.useEffect(
    () => {
      if (loadedAuthorization) {
        setSelectedChildrens(
          initialValues?.pickup_authorization_children.map(item => ({
            name: item?.child?.name,
            id: +item?.child?.id
          }))
        )

        const permanentAuthorization = !!(
          String(initialValues?.pickup_type) === 'permanent'
        )
        setPermanentAuthorization(prev => ({
          ...prev,
          value: permanentAuthorization
        }))

        setResponsiblePhoto(prev => {
          return { ...prev, url: initialValues?.photo_url }
        })
      }
    },
    [initialValues]
  )

  React.useEffect(
    () => {
      return () => {
        if (responsiblePhoto.url) {
          URL.revokeObjectURL(responsiblePhoto.url)
        }
      }
    },
    [responsiblePhoto]
  )

  const handleChangePhoto = event => {
    handleAddAvatar(
      event,
      setUploadingInProgress,
      alert,
      param =>
        setResponsiblePhoto(() => {
          return { file: param, url: URL.createObjectURL(param), delete: false }
        }),
      heic2any
    )
  }

  const handleRemovePhoto = event => {
    if (event && event.stopPropagation) event.stopPropagation()
    setResponsiblePhoto(prev => {
      URL.revokeObjectURL(prev.url)
      return { url: null, file: null, delete: !!prev.url }
    })
  }

  const handleClickPhotoInput = () => {
    reponsiblePhotoRef.current && reponsiblePhotoRef.current.click()
  }

  const goBack = () => {
    history.push('/pickup/authorizations')
  }

  const handleSubmitForm = () => {
    if (valid && selectedChildrens.length > 0) {
      const { pickup_estimate, ...rest } = fieldValues
      const basicData = {
        authorized_by_id: selectedParent?.[0].id,
        pickup_type: permanentAuthorization.value ? 'permanent' : 'temporary',
        ...(!permanentAuthorization.value && !!pickup_estimate
          ? {
              estimated_arrival: moment(pickup_estimate).format(
                'YYYY-MM-DD HH:mm'
              )
            }
          : {}),
        photo: responsiblePhoto.delete ? 'delete' : responsiblePhoto.file
      }
      setOpenBackdrop(true)
      if (isEdit) {
        const {
          name,
          email,
          phone,
          relationship_type,
          taxpayer_number,
          vehicle_plate
        } = fieldValues

        const addPAChild = []
        const findChild = id =>
          initialValues.pickup_authorization_children.find(
            pachild => +pachild.child_id === +id
          )
        selectedChildrens.forEach(child => {
          const pickupAuthorizationChild = findChild(child.id)
          !pickupAuthorizationChild && addPAChild.push({ child_id: child.id })
        })

        const removePAChild = initialValues?.pickup_authorization_children.filter(
          pachild => {
            const childFinded = selectedChildrens.find(
              child => +child.id === +pachild.child_id
            )
            return !childFinded
          }
        )

        return editPickupAuthorizationRSPA({
          id: currentAuthorization.id,
          data: {
            ...basicData,
            pickup_authorization_children_attributes: addPAChild
              .map(({ child_id }) => ({ child_id }))
              .concat(
                removePAChild.map(item => ({ id: item.id, _destroy: true }))
              ),
            name: capitalize(name),
            email,
            phone,
            relationship_type,
            taxpayer_number,
            vehicle_plate
          }
        })
          .then(res => {
            alert('Autorização editada com sucesso!', 'success')
          })
          .catch(err => {
            console.error(err)
            alert('Erro ao editar autorização.', 'error')
          })
          .finally(() => {
            setOpenBackdrop(false)
            goBack()
          })
      }
      createPickupAuthorizationRSPA({
        ...rest,
        ...basicData,
        status: 'approved',
        pickup_authorization_children_attributes: selectedChildrens.map(
          item => ({
            child_id: item.id
          })
        ),
        school_id: schoolId,
        admin_id: currentUser.id
      })
        .then(res => {
          alert('Autorização criada com sucesso!', 'success')
        })
        .catch(err => {
          console.error(err)
          alert('Erro ao criar autorização.', 'error')
        })
        .finally(() => {
          setOpenBackdrop(false)
          goBack()
        })
    }
  }

  const handleChangeAuthorizationType = canPick => {
    setPermanentAuthorization(prev => ({ ...prev, value: canPick }))
  }

  if (isEdit && isEmpty(initialValues)) {
    return (
      <div className={classes.root}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <div
        className={`${classes.input_select_wrapper} ${classes.parent_select}`}
      >
        <div>
          <h1 className='input-label'>Solicitação de cadastro</h1>
          <p className='description'>
            Informe quem está solicitando este cadastro para fins de registro
            interno.
          </p>
        </div>
        <InputSelect
          selectedItems={selectedParent}
          setSelectedItems={setSelectedParent}
          fetchItems={getUsers}
          placeholder={'Digite o nome de quem solicitou o cadastro'}
          label={
            <p>
              Solicitante<span className={classes.bull}>&bull;</span>
            </p>
          }
          params={{
            'q[pickup_authorizations_user_id_not_null]': true,
            'q[pickup_authorizations_school_id_eq]': schoolId
          }}
        />
      </div>
      <div className={classes.input_select_wrapper}>
        <h1 className='input-label'>Aluno</h1>
        <InputSelect
          isMulti
          selectedItems={selectedChildrens}
          setSelectedItems={setSelectedChildrens}
          fetchItems={getChildrenRSPA}
          placeholder={'Digite o(s) nome(s) do(s) aluno(s)'}
          label={'Nome do aluno'}
          disabled={selectedParent.length < 1}
          params={{
            'page[size]': 7,
            'q[pickup_authorization_children_pickup_authorization_user_id_eq]':
              selectedParent?.[0]?.id
          }}
        />
      </div>
      <div className={classes.radio_wrapper}>
        <div className='radioButton'>
          <Radio
            disabled={isEdit}
            value={!!permanentAuthorization.value}
            checked={!!permanentAuthorization.value}
            onChange={() => handleChangeAuthorizationType(true)}
          />
          <p>Autorização fixa</p>
        </div>
        <div className='radioButton'>
          <Radio
            disabled={isEdit}
            value={!permanentAuthorization.value}
            checked={!permanentAuthorization.value}
            onChange={() => handleChangeAuthorizationType(false)}
          />
          <p>Somente hoje</p>
        </div>
      </div>
      <div className={classes.responsible_section}>
        <p className='label'>Dados do responsável</p>
        <div className={classes.responsible_fields}>
          <PhotoInput
            bgImg={`url(${responsiblePhoto.url})`}
            onClick={handleClickPhotoInput}
          >
            {!uploadingInProgress ? (
              !responsiblePhoto.url && (
                <div className={classes.without_photo}>
                  <StyledSVG src={cameraSVG} width={40} height={40} />
                  <p>Adicionar foto</p>
                </div>
              )
            ) : (
              <CircularProgress />
            )}
            {responsiblePhoto.url && (
              <HighlightOffIcon
                onClick={handleRemovePhoto}
                className={classes.remove_photo}
              />
            )}
            <input
              accept='.png, .jpg, .jpeg, .heic'
              hidden
              name='avatar'
              onChange={handleChangePhoto}
              ref={reponsiblePhotoRef}
              type='file'
            />
          </PhotoInput>
          <div className={classes.contact_infos}>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>Nome completo</p>
              <Field
                rootClass={`${classes.material_input_class} ${
                  classes.capitalized_input
                }`}
                component={MaterialInput}
                name='name'
                placeholder='Digite o nome completo'
                type='text'
                autoComplete='off'
                validate={[required]}
              />
            </FormFieldWrapper>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>Relação com a criança</p>
              <Field
                rootClass={classes.material_input_class}
                component={RelationSelect}
                name='relationship_type'
                placeholder='Ex: Tio'
              />
            </FormFieldWrapper>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>Email</p>
              <Field
                rootClass={classes.material_input_class}
                component={MaterialInput}
                name='email'
                placeholder='Digite o email'
                type='email'
                autoComplete='off'
                validate={[required, validEmail]}
              />
            </FormFieldWrapper>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>CPF</p>
              <Field
                allowClear
                rootClass={classes.material_input_class}
                component={MaterialInput}
                name={`taxpayer_number`}
                placeholder='CPF'
                type='text'
                autoComplete='off'
                normalize={normalizeCPF}
                validate={[required, isValidCPF]}
              />
            </FormFieldWrapper>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>Telefone</p>
              <Field
                rootClass={classes.material_input_class}
                component={MaterialInput}
                name='phone'
                placeholder='Ex:(61) 99999-9999'
                type='text'
                autoComplete='off'
                normalize={normalizePhone}
                validate={[required, validPhone]}
              />
            </FormFieldWrapper>
            <FormFieldWrapper
              gridColumn={3}
              className={`${classes.search_field}`}
            >
              <p className='label'>Placa do veículo</p>
              <Field
                rootClass={classes.material_input_class}
                component={MaterialInput}
                name='vehicle_plate'
                placeholder='Ex:ABC1D23'
                type='vehicle_plate'
                autoComplete='off'
              />
            </FormFieldWrapper>
          </div>
        </div>
      </div>
      {!permanentAuthorization.value && (
        <div className={classes.estimated_arrival}>
          <h1>Previsão de chegada</h1>
          <div className='input_wrapper'>
            <p>
              Informe aproximadamente quando o responsável deve chegar à escola.
            </p>
            <Field
              rootClass={classes.time_picker_class}
              component={TimePickerInput}
              defaultValue={initialValues?.estimated_arrival}
              id='pickup_estimate'
              name='pickup_estimate'
              placeholder='00:00'
            />
          </div>
        </div>
      )}
      <div className={classes.warning_section}>
        <StyledSVG src={warningSVG} height={24} width={24} />
        <WarningMessage
          permanent={!!permanentAuthorization.value}
          classes={classes}
        />
      </div>
      <div className={classes.bottom_btns}>
        <Button
          onclick={() => goBack()}
          type='button'
          variant='outlined'
          className={classes.cancel_btn}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => handleSubmitForm()}
          disabled={
            !valid ||
            selectedParent.length === 0 ||
            selectedChildrens.length === 0
          }
          className={classes.send_btn}
        >
          {isEdit ? 'Editar' : 'Criar'}
        </Button>
      </div>
      <Backdrop className={classes.backdrop} open={openBackdrop}>
        <CircularProgress color='secondary' />
      </Backdrop>
    </div>
  )
}

export default CreatePickupAuthorizationsForm
